import * as Types from '../constants/Types';

export const getListFareRules = (filters) => ({ type: Types.FARE_RULE_LIST_ACTION, filters });
export const setListFareRules = (fareRules) => ({ type: Types.FARE_RULE_LIST_SUCCESS, fareRules});

export const getFareRuleDetail = (id) => ({ type: Types.FARE_RULE_DETAIL_ACTION, id })
export const setFareRuleDetail = (fareRule) => ({ type: Types.FARE_RULE_DETAIL_SUCCESS, fareRule });

export const updateFareRuleDetail = (fareRule) => ({ type: Types.FARE_RULE_DETAIL_UPDATE_ACTION, fareRule });
export const createFareRuleDetail = (fareRule) => ({ type: Types.FARE_RULE_DETAIL_CREATE_ACTION, fareRule });
export const deleteFareRuleDetail = (fareRule, filters) => ({ type: Types.FARE_RULE_DETAIL_DELETE_ACTION, fareRule, filters });

export const createFareRuleTranslate = (fareRule) => ({type: Types.FARE_RULE_CREATE_TRANSLATE_ACTION, fareRule});
export const updateFareRuleTranslate = (fareRule) => ({type: Types.FARE_RULE_UPDATE_TRANSLATE_ACTION, fareRule});
export const deleteFareRuleTranslate = (fareRule, refreshParams) => ({type: Types.FARE_RULE_DELETE_TRANSLATE_ACTION, fareRule, refreshParams});